module.exports = {
      id: "ic-help-center-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-help-center-usage",
      toString: function () {
        return this.url;
      }
    }